var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictoPhone2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.061 0.000244141C35.3369 0.000244141 28.2393 7.09787 28.2393 15.822C28.2393 19.4564 29.4566 22.904 31.6981 25.6987L28.7541 28.6426C28.2513 29.1454 28.1009 29.9016 28.373 30.5585C28.6451 31.2154 29.2862 31.6437 29.9971 31.6437H44.0609C52.8496 31.6437 59.9998 24.5461 59.9998 15.822C59.9998 7.09787 52.8497 0.000244141 44.061 0.000244141ZM42.2512 40.2412C40.1951 38.1851 36.8491 38.185 34.7927 40.2412L32.3066 42.7274C31.9746 43.0594 31.5331 43.2423 31.0635 43.2423C30.5939 43.2423 30.1525 43.0594 29.8261 42.7332L17.2726 30.0624C16.9406 29.7303 16.7576 29.2889 16.7576 28.8192C16.7576 28.3497 16.9406 27.9083 17.2726 27.5762L19.7588 25.0901C21.8151 23.0338 21.8151 19.688 19.7588 17.6318L13.5433 11.4163C11.4872 9.36003 8.14121 9.35991 6.08497 11.4163L3.59884 13.9024C-1.19913 18.7004 -1.19913 26.5074 3.59591 31.3025L28.5775 56.4013C30.9765 58.8004 34.1276 59.9999 37.279 59.9999C40.4303 59.9999 43.5814 58.8004 45.9805 56.4013L48.4666 53.9152C50.523 51.859 50.523 48.5131 48.4666 46.4568L42.2512 40.2412Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.061 14.0641C43.0901 14.0641 42.303 14.8512 42.303 15.8221V22.854C42.303 23.8248 43.0901 24.6119 44.061 24.6119C45.0319 24.6119 45.819 23.8248 45.819 22.854V15.8221C45.819 14.8511 45.0319 14.0641 44.061 14.0641ZM44.061 10.5482C45.0319 10.5482 45.819 9.76107 45.819 8.7902C45.819 7.81933 45.0319 7.03223 44.061 7.03223C43.0901 7.03223 42.303 7.81933 42.303 8.7902C42.303 9.76107 43.0901 10.5482 44.061 10.5482Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 16.0589,
    y1: 43.8827,
    x2: 55.3142,
    y2: 4.62733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A93AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF81FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 39.3019,
    y1: 20.581,
    x2: 48.8199,
    y2: 11.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF1FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoPhone2);
export default __webpack_public_path__ + "static/media/picto_phone2.5a56f646b7dbe22ca5396a5ca40c3470.svg";
export { ForwardRef as ReactComponent };